import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PlaceIcon from '@mui/icons-material/Place';
import { Stack } from '@mui/material';

import { EstimatedWaveSpectrumSection } from '@/components/spotter/historicalDataTab/EstimatedWaveSpectrumSection';
import { SpotterTrackMap } from '@/components/spotter/historicalDataTab/SpotterTrackMap';
import { InlineAlertPrimaryButton } from '@/components/ui/InlineAlert';
import { ResizableSidePanel } from '@/components/ui/ResizableSidePanel';
import { useTetherDeviceIdentity } from '@/hooks/useTetherDeviceIdentity';

export const ObservationDetailsPanel = () => {
    const { isScout, tetherDashboardUrl } = useTetherDeviceIdentity();

    return (
        <ResizableSidePanel
            sx={{
                top: 5,
                ml: '6px',
                mr: '-32px',
                position: 'sticky',
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
            }}
            side="right"
            maxWidth={0.5}
            collapsedIcon={<PlaceIcon />}
        >
            <Stack sx={{ m: 1, gap: 1 }}>
                <SpotterTrackMap />
                {isScout && (
                    <InlineAlertPrimaryButton
                        component="a"
                        variant="outlined"
                        href={tetherDashboardUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        View on Tether <OpenInNewIcon sx={{ ml: 0.5, fontSize: '1rem' }} />
                    </InlineAlertPrimaryButton>
                )}
                <EstimatedWaveSpectrumSection />
            </Stack>
        </ResizableSidePanel>
    );
};
